// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationGroupAlertId } from './FermentationGroupAlert';
import { fermentationAttributeDefinitionId } from './FermentationAttributeDefinition';
import { z } from 'zod';
export const fermentationGroupAlertSignalId = (z.number());
export const fermentationGroupAlertSignal = z.object({
    id: fermentationGroupAlertSignalId,
    group_alert_id: fermentationGroupAlertId,
    attribute_id: fermentationAttributeDefinitionId,
    created_at: z.date(),
});
export const fermentationGroupAlertSignalInitializer = z.object({
    id: fermentationGroupAlertSignalId.optional(),
    group_alert_id: fermentationGroupAlertId,
    attribute_id: fermentationAttributeDefinitionId,
    created_at: z.date().optional(),
});
export const fermentationGroupAlertSignalMutator = z.object({
    id: fermentationGroupAlertSignalId.optional(),
    group_alert_id: fermentationGroupAlertId.optional(),
    attribute_id: fermentationAttributeDefinitionId.optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=FermentationGroupAlertSignal.js.map